import { API, Auth } from 'aws-amplify';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { RootState, useDispatch, useSelector } from 'src/store';
import { buttonsReset } from 'src/store/modules/buttons';
import { editUserCompany } from 'src/store/modules/client';
import { editTextReset } from 'src/store/modules/editText';
import { imageReset } from 'src/store/modules/imageUpload';
import { trackingReset } from 'src/store/modules/trackings';
import { changeEnter } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import setInitValue from 'src/utils/setInitValue';
import { initTrackingValues } from '../TemplateTracking/ChoiceOptionImageTracking';
import { switchReset } from 'src/store/modules/switchButton';

const initViewValues = {
  bg: 'color',
  bgColor: { background: '#ffffff' },
  bgImage: {
    top_image: 'https://image.inappmessage.com/sample/default_image_2*1.webp',
    bottom_image:
      'https://image.inappmessage.com/sample/default_image_2*1.webp',
    top_left_image:
      'https://image.inappmessage.com/sample/default_image_1*1.png',
    top_right_image:
      'https://image.inappmessage.com/sample/default_image_1*1.png',
    bottom_left_image:
      'https://image.inappmessage.com/sample/default_image_1*1.png',
    bottom_right_image:
      'https://image.inappmessage.com/sample/default_image_1*1.png'
  },
  radius: {
    top_image: 20,
    bottom_image: 20,
    top_left_image: 20,
    top_right_image: 20,
    bottom_left_image: 20,
    bottom_right_image: 20,
    close_button: 16
  },
  deeplink: {
    top_image: 'https://www.inappmessage.com/',
    bottom_image: 'https://www.inappmessage.com/',
    top_left_image: 'https://www.inappmessage.com/',
    top_right_image: 'https://www.inappmessage.com/',
    bottom_left_image: 'https://www.inappmessage.com/',
    bottom_right_image: 'https://www.inappmessage.com/'
  },
  text: {
    title: 'Select your favorite',
    sub_title: 'Select your favorite'
  },
  fontSize: { title: 2, sub_title: 1 },
  fontWeight: { title: 700, sub_title: 400 },
  color: { title: '#000000', sub_title: '#000000' },
  fontFamily: { title: 'Inter', sub_title: 'Inter' },
  textAlign: { title: 'center', sub_title: 'center' },
  btnText: {
    top_image_button: 'Select',
    bottom_image_button: 'Select',
    top_left_image_button: 'Select',
    top_right_image_button: 'Select',
    bottom_left_image_button: 'Select',
    bottom_right_image_button: 'Select',
    close_button: 'Close'
  },
  btnFontSize: {
    top_image_button: 1,
    bottom_image_button: 1,
    top_left_image_button: 1,
    top_right_image_button: 1,
    bottom_left_image_button: 1,
    bottom_right_image_button: 1,
    close_button: 1
  },
  btnFontWeight: {
    top_image_button: 700,
    bottom_image_button: 700,
    top_left_image_button: 700,
    top_right_image_button: 700,
    bottom_left_image_button: 700,
    bottom_right_image_button: 700,
    close_button: 700
  },
  btnColor: {
    top_image_button: '#000000',
    bottom_image_button: '#000000',
    top_left_image_button: '#000000',
    top_right_image_button: '#000000',
    bottom_left_image_button: '#000000',
    bottom_right_image_button: '#000000',
    close_button: '#B0B0B0'
  },
  btnBgColorR: {
    top_image_button: 255,
    bottom_image_button: 255,
    top_left_image_button: 255,
    top_right_image_button: 255,
    bottom_left_image_button: 255,
    bottom_right_image_button: 255,
    close_button: 255
  },
  btnBgColorG: {
    top_image_button: 255,
    bottom_image_button: 255,
    top_left_image_button: 255,
    top_right_image_button: 255,
    bottom_left_image_button: 255,
    bottom_right_image_button: 255,
    close_button: 255
  },
  btnBgColorB: {
    top_image_button: 255,
    bottom_image_button: 255,
    top_left_image_button: 255,
    top_right_image_button: 255,
    bottom_left_image_button: 255,
    bottom_right_image_button: 255,
    close_button: 255
  },
  btnBgColorA: {
    top_image_button: 1,
    bottom_image_button: 1,
    top_left_image_button: 1,
    top_right_image_button: 1,
    bottom_left_image_button: 1,
    bottom_right_image_button: 1,
    close_button: 1
  },
  btnFontFamily: {
    top_image_button: 'Pretendard',
    bottom_image_button: 'Pretendard',
    top_left_image_button: 'Pretendard',
    top_right_image_button: 'Pretendard',
    bottom_left_image_button: 'Pretendard',
    bottom_right_image_button: 'Pretendard',
    close_button: 'Pretendard'
  },
  btnAgain: {
    type: 'none',
    close_button: "don't show"
  },
  button1: {
    top_image_button: [],
    bottom_image_button: [],
    top_left_image_button: [],
    top_right_image_button: [],
    bottom_left_image_button: [],
    bottom_right_image_button: [],
    close_button: []
  },
  button2: {
    top_image_button: [],
    bottom_image_button: [],
    top_left_image_button: [],
    top_right_image_button: [],
    bottom_left_image_button: [],
    bottom_right_image_button: [],
    close_button: []
  },
  switchImageType: 'quard'
};

const ChoiceOptionImage = () => {
  const dispatch = useDispatch();
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);

  let radius = useSelector((state: RootState) => state.imageUpload.radius);
  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  let switchImageType = useSelector(
    (state: RootState) => state.switchButton.switchImageType
  );

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });

    onLoad();
    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(trackingReset());
      dispatch(switchReset());
    };
  }, []);
  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const topImageButtonFontURL = getFontURL(btnFontFamily?.top_image_button);
  const bottomImageButtonFontURL = getFontURL(
    btnFontFamily?.bottom_image_button
  );
  const topLeftImageButtonFontURL = getFontURL(
    btnFontFamily?.top_left_image_button
  );
  const topRightImageButtonFontURL = getFontURL(
    btnFontFamily?.top_right_image_button
  );
  const bottomLeftImageButtonFontURL = getFontURL(
    btnFontFamily?.bottom_left_image_button
  );
  const bottomRightImageButtonFontURL = getFontURL(
    btnFontFamily?.bottom_right_image_button
  );
  const buttonFontURL = getFontURL(btnFontFamily?.close_button);

  const style = `
      @font-face {
        font-family: 'title';
        src: url(${titleFontURL});
      }
      @font-face {
        font-family: 'subTitle';
        src: url(${subTitleFontURL});
      }
      @font-face {
        font-family: 'topImageButton';
        src: url(${topImageButtonFontURL});
      }
      @font-face {
        font-family: 'bottomImageButton';
        src: url(${bottomImageButtonFontURL});
      }
      @font-face {
        font-family: 'topLeftImageButton';
        src: url(${topLeftImageButtonFontURL});
      }
      @font-face {
        font-family: 'topRightImageButton';
        src: url(${topRightImageButtonFontURL});
      }
      @font-face {
        font-family: 'bottomLeftImageButton';
        src: url(${bottomLeftImageButtonFontURL});
      }
      @font-face {
        font-family: 'bottomRightImageButton';
        src: url(${bottomRightImageButtonFontURL});
      }
      @font-face {
        font-family: 'button';
        src: url(${buttonFontURL});
      }

			.root_view {
				width: 100%;
				height: 100%;
				position: relative;				
			}

			.in-app-wrapper {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: space-between;
				width: 100%;

				height: 100%;
				padding: 64px 32px 32px 32px;
				background: ${bgColor?.background};
			}

			.content-wrapper {
				display: flex;
				flex-direction: column;
				gap: 5px;
				width: 100%;
				height: auto;
				max-width: 390px;
			}

			.title-container {
				width: 100%;
				height: auto;
				max-height: 120px;
			}

			.main-title {
				font-size: ${fontSize?.title}rem;
				font-weight: ${fontWeight?.title};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            fontFamily?.title
          )
            ? fontFamily?.title
            : 'title'
        };
				line-height: 1.4;
				text-align: ${textAlign?.title};
				color: ${color?.title};        
			}  

			.subtitle-container {
				width: 100%;
				height: auto;
				max-height: 100px;
			}

			.subtitle {
				font-size: ${fontSize?.sub_title}rem;
				font-weight: ${fontWeight?.sub_title};
         font-family: ${
           ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
             fontFamily?.sub_title
           )
             ? fontFamily?.sub_title
             : 'subTitle'
         };
				line-height: 1.4;
				text-align: ${textAlign?.sub_title};
				color: ${color?.sub_title};
			}  

			.image-grid {
				display: flex;
				flex-direction: column;
				align-items: center;
				max-width: 320px;
				width: 100%;
				height: auto;
				gap: 10px;
			}

			.image-large-container {
				display: flex;
				flex-direction: column;
				width: 100%;
				max-width: 320px;
				aspect-ratio: 3 / 2;								
				overflow: hidden;				
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
			}

			.image-wrapper {
				width: 100%;
				height: 75%;
        background: #D9D9D9;
			}

			.image {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
	
			.image-title {
				text-align: center;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;				
				line-height: 1.4;
			}

      .top-title {
        font-size: ${btnFontSize?.top_image_button}rem;
				font-weight: ${btnFontWeight?.top_image_button};
				color: ${btnColor?.top_image_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            btnFontFamily?.top_image_button
          )
            ? btnFontFamily?.top_image_button
            : 'topImageButton'
        };
      } 

			.bottom-title {
        font-size: ${btnFontSize?.bottom_image_button}rem;
				font-weight: ${btnFontWeight?.bottom_image_button};
				color: ${btnColor?.bottom_image_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            btnFontFamily?.bottom_image_button
          )
            ? btnFontFamily?.bottom_image_button
            : 'bottomImageButton'
        };
      } 

			.top-left-title {
        font-size: ${btnFontSize?.top_left_image_button}rem;
				font-weight: ${btnFontWeight?.top_left_image_button};
				color: ${btnColor?.top_left_image_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            btnFontFamily?.top_left_image_button
          )
            ? btnFontFamily?.top_left_image_button
            : 'topLeftImageButton'
        };
      } 
			.top-right-title {
        font-size: ${btnFontSize?.top_right_image_button}rem;
				font-weight: ${btnFontWeight?.top_right_image_button};
				color: ${btnColor?.top_right_image_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            btnFontFamily?.top_right_image_button
          )
            ? btnFontFamily?.top_right_image_button
            : 'topRightImageButton'
        };
      } 

			.bottom-left-title {
        font-size: ${btnFontSize?.bottom_left_image_button}rem;
				font-weight: ${btnFontWeight?.bottom_left_image_button};
				color: ${btnColor?.bottom_left_image_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            btnFontFamily?.bottom_left_image_button
          )
            ? btnFontFamily?.bottom_left_image_button
            : 'bottomLeftImageButton'
        };
      } 

			.bottom-right-title {
        font-size: ${btnFontSize?.bottom_right_image_button}rem;
				font-weight: ${btnFontWeight?.bottom_right_image_button};
				color: ${btnColor?.bottom_right_image_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            btnFontFamily?.bottom_right_image_button
          )
            ? btnFontFamily?.bottom_right_image_button
            : 'bottomRightImageButton'
        };
      } 

			.image-row {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				width: 100%;
				max-width: 320px;
				height: auto;				                
			}

			.image-small-container {
				width: 48%;
				max-width: 150px;
				aspect-ratio: 3 / 4;
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);				
				overflow: hidden;
			}

			.close-button {
				width: 100%;
				height: 60px;
				max-width: 320px;
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: ${radius?.close_button}px;
				background: rgba(${btnBgColorR?.close_button},${btnBgColorG?.close_button}, ${
    btnBgColorB?.close_button
  }, ${btnBgColorA?.close_button});
			}

			.close-text {
				font-size: ${btnFontSize?.close_button}rem;
				font-weight: ${btnFontWeight?.close_button};
				color: ${btnColor?.close_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            btnFontFamily?.close_button
          )
            ? btnFontFamily?.close_button
            : 'closeButton'
        };
				line-height: 1.4;
				text-align: center;
			}
			
			.image-large-title-container {
				width: 100%;
				height: 25%;
				background: rgba(${btnBgColorR?.top_image_button},${
    btnBgColorG?.top_image_button
  }, ${btnBgColorB?.top_image_button}, ${btnBgColorA?.top_image_button});
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 0 10px;
			}
      .image-title-container {
				width: 100%;
				height: 25%;
				display: flex;
				justify-content: center;
				align-items: center;
				padding: 0 10px;
      }

			.image-large-title {
				text-align: center;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				font-size: ${btnFontSize?.top_image_button}rem;
				font-weight: ${btnFontWeight?.top_image_button};
				color: ${btnColor?.top_image_button};
				line-height: 1.4;
			}

			.top{
      border-radius: ${radius?.top_image}px;
      }
      .bottom{
      border-radius: ${radius?.bottom_image}px;
      }
      .top-left{
      border-radius: ${radius?.top_left_image}px;
      }
      .top-right{
      border-radius: ${radius?.top_right_image}px;
      }
      .bottom-left{
      border-radius: ${radius?.bottom_left_image}px;
      }
      .bottom-right{
      border-radius: ${radius?.bottom_right_image}px;
      }

			.top-container {
				background: rgba(${btnBgColorR?.top_image_button},${
    btnBgColorG?.top_image_button
  }, ${btnBgColorB?.top_image_button}, ${btnBgColorA?.top_image_button});
			}

			.bottom-container {
				background: rgba(${btnBgColorR?.bottom_image_button},${
    btnBgColorG?.bottom_image_button
  }, ${btnBgColorB?.bottom_image_button}, ${btnBgColorA?.bottom_image_button});
			}
			
			.top-left-container {
				background: rgba(${btnBgColorR?.top_left_image_button},${
    btnBgColorG?.top_left_image_button
  }, ${btnBgColorB?.top_left_image_button}, ${
    btnBgColorA?.top_left_image_button
  });
			}

			.top-right-container {
				background: rgba(${btnBgColorR?.top_right_image_button},${
    btnBgColorG?.top_right_image_button
  }, ${btnBgColorB?.top_right_image_button}, ${
    btnBgColorA?.top_right_image_button
  });
			}

			.bottom-left-container {
				background: rgba(${btnBgColorR?.bottom_left_image_button},${
    btnBgColorG?.bottom_left_image_button
  }, ${btnBgColorB?.bottom_left_image_button}, ${
    btnBgColorA?.bottom_left_image_button
  });
			}

			.bottom-right-container {
				background: rgba(${btnBgColorR?.bottom_right_image_button},${
    btnBgColorG?.bottom_right_image_button
  }, ${btnBgColorB?.bottom_right_image_button}, ${
    btnBgColorA?.bottom_right_image_button
  });
			}
		
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_view">
        <div className="in-app-wrapper">
          <div className="content-wrapper">
            <div className="title-container">
              <p className="main-title">{changeEnter(text?.title)}</p>
            </div>
            <div className="subtitle-container">
              <p className="subtitle">{changeEnter(text?.sub_title)}</p>
            </div>
          </div>
          <div className="image-grid">
            {switchImageType && switchImageType === 'double' ? (
              <>
                {/* <!-- option 1 : Large image count 2 --> */}
                <div className="image-large-container top">
                  <div className="image-wrapper">
                    <img className="image" src={bgImage?.top_image} alt="" />
                  </div>
                  <div className="image-large-title-container top-container">
                    <div className="image-large-title top-title">
                      {changeEnter(btnText?.top_image_button)}
                    </div>
                  </div>
                </div>
                <div className="image-large-container bottom">
                  <div className="image-wrapper">
                    <img className="image" src={bgImage?.bottom_image} alt="" />
                  </div>
                  <div className="image-large-title-container bottom-container">
                    <div className="image-large-title bottom-title">
                      {changeEnter(btnText?.bottom_image_button)}
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {/* <!-- option 2 : Small image count 4 --> */}
                <div className="image-row">
                  <div className="image-small-container top-left">
                    <div className="image-wrapper">
                      <img
                        className="image"
                        src={bgImage?.top_left_image}
                        alt=""
                      />
                    </div>
                    <div className="image-title-container top-left-container">
                      <div className="image-title top-left-title">
                        {changeEnter(btnText?.top_left_image_button)}
                      </div>
                    </div>
                  </div>
                  <div className="image-small-container top-right">
                    <div className="image-wrapper">
                      <img
                        className="image"
                        src={bgImage?.top_right_image}
                        alt=""
                      />
                    </div>
                    <div className="image-title-container top-right-container">
                      <div className="image-title top-right-title">
                        {changeEnter(btnText?.top_right_image_button)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="image-row">
                  <div className="image-small-container bottom-left">
                    <div className="image-wrapper">
                      <img
                        className="image"
                        src={bgImage?.bottom_left_image}
                        alt=""
                      />
                    </div>
                    <div className="image-title-container bottom-left-container">
                      <div className="image-title bottom-left-title">
                        {changeEnter(btnText?.bottom_left_image_button)}
                      </div>
                    </div>
                  </div>
                  <div className="image-small-container bottom-right">
                    <div className="image-wrapper">
                      <img
                        className="image"
                        src={bgImage?.bottom_right_image}
                        alt=""
                      />
                    </div>
                    <div className="image-title-container bottom-right-container">
                      <div className="image-title bottom-right-title">
                        {changeEnter(btnText?.bottom_right_image_button)}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="close-button">
            <p className="close-text">{changeEnter(btnText?.close_button)}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChoiceOptionImage;
